module.exports = __webpack_public_path__ + "media/images/flags/16/Russia-21764a26f83f49eff8e619af9c92689c.png";